import { usePredictionEventTitle } from '@src/hooks/usePredictionEventTitle';
import {
  HStack,
  SecurityTypesUtils,
  SmartSummary,
  Text,
  isOrder,
  useSecurity,
  type SmartSummaryProps,
} from '@talos/kyoko';
import { PredictionOutcomeTag } from '../../../../components/PredictionMarkets/PredictionOutcomeTag';

/**
 * Ava SmartSummary wrapper that, for prediction-outcome securities, renders
 * outcome + muted event title before the usual side/qty/price/strategy summary.
 */
export function PredictionAwareSmartSummary({ showSymbol = false, ...props }: SmartSummaryProps) {
  const security = useSecurity(props.entity.Symbol);
  const isPredictionOutcome = SecurityTypesUtils.PredictionOutcome.isType(security);
  const eventTitle = usePredictionEventTitle(security);

  if (!showSymbol || !isPredictionOutcome) {
    return <SmartSummary {...props} showSymbol={showSymbol} />;
  }

  return (
    <HStack gap="spacing4" overflow="hidden">
      <Text color="colorTextImportant" data-testid="order-symbol">
        {security.DisplaySymbol ?? security.Symbol}
      </Text>
      {isOrder(props.entity) && <PredictionOutcomeTag outcome={props.entity.ExpressedOutcome} />}
      {eventTitle != null && (
        <Text weight="fontWeightRegular" color="colorTextSubtle" data-testid="order-event">
          {eventTitle}
        </Text>
      )}
      <SmartSummary {...props} showSymbol={false} />
    </HStack>
  );
}
